import AccountExpiringDateBadge from "components/client/AccountExpiringDateBadge";

/** Duplikium connection status + balance + expiration for subscription account rows. */
export default function SlaveAccountRowStatus({
  row,
  statusLoadingId,
  onRefresh,
  variant = "inline",
}) {
  const isFooter = variant === "footer";

  if (row.subscriptionExpired) {
    return (
      <div
        className={
          isFooter
            ? "flex flex-wrap items-center gap-x-6 gap-y-2 text-sm"
            : "flex max-w-[16rem] flex-col items-end gap-1.5 text-right"
        }
      >
        <div className={isFooter ? "flex items-center gap-2" : ""}>
          <span className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
            Status
          </span>
          <span className="font-bold text-red-700 dark:text-red-400">Expired</span>
        </div>
        {!isFooter ? (
          <p className="text-xs font-semibold text-red-600 dark:text-red-400">
            Copy trading stopped
          </p>
        ) : null}
        <div className={isFooter ? "flex items-center gap-2" : ""}>
          {isFooter ? (
            <span className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
              Expiration
            </span>
          ) : null}
          <AccountExpiringDateBadge
            expiringDate={row.expiringDate}
            className={isFooter ? "" : "!text-right"}
          />
        </div>
      </div>
    );
  }

  if (row.brokerConnected) {
    return (
      <div
        className={
          isFooter
            ? "flex flex-wrap items-center gap-x-6 gap-y-2 text-sm"
            : "flex max-w-[16rem] flex-col items-end gap-1.5 text-right"
        }
      >
        <div className={isFooter ? "flex items-center gap-2" : ""}>
          <span className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
            Status
          </span>
          <span className="font-bold text-emerald-700 dark:text-emerald-300">
            Connected
          </span>
        </div>
        {!isFooter && row.balanceDisplay ? (
          <span className="whitespace-nowrap text-xs font-semibold text-emerald-700 dark:text-emerald-300">
            {row.balanceDisplay}
          </span>
        ) : null}
        {isFooter && row.balanceDisplay ? (
          <span className="whitespace-nowrap text-xs font-semibold text-emerald-700 dark:text-emerald-300">
            {row.balanceDisplay}
          </span>
        ) : null}
        <div className={isFooter ? "flex items-center gap-2" : ""}>
          {isFooter ? (
            <span className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
              Expiration
            </span>
          ) : null}
          <AccountExpiringDateBadge
            expiringDate={row.expiringDate}
            className={isFooter ? "" : "!text-right"}
          />
        </div>
      </div>
    );
  }

  if (row.linkedToCopier || row.tradeCopierAccountId) {
    const pending = String(row.brokerState || "").toUpperCase() === "NONE";
    return (
      <div
        className={
          isFooter
            ? "flex flex-wrap items-center gap-x-6 gap-y-2 text-sm"
            : "flex max-w-[14rem] flex-col items-end gap-1 text-right"
        }
      >
        <div className={isFooter ? "flex items-center gap-2" : ""}>
          <span className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
            Status
          </span>
          <span className="font-bold text-navy-800 dark:text-white">
            {pending ? "Connecting…" : "Disconnected"}
          </span>
        </div>
        {typeof onRefresh === "function" ? (
          <button
            type="button"
            disabled={statusLoadingId === row.id}
            onClick={() => onRefresh(row.id)}
            className="text-xs font-semibold text-brand-600 hover:underline disabled:opacity-50 dark:text-brand-300"
          >
            {statusLoadingId === row.id ? "Refreshing…" : "Refresh"}
          </button>
        ) : null}
        {row.expiringDate ? (
          <div className={isFooter ? "flex items-center gap-2" : ""}>
            {isFooter ? (
              <span className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
                Expiration
              </span>
            ) : null}
            <AccountExpiringDateBadge expiringDate={row.expiringDate} />
          </div>
        ) : null}
      </div>
    );
  }

  return null;
}
